module.exports = __webpack_public_path__ + "img/rabbuttz.7ec908e7.jpg";